/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


 import React, { Component } from "react";
import asyncCallHandler from '../../common/utils/asyncCallHandler'
import EDW_CONST from '../../common/constants';
import style from '../../component/common/style/index.scss';
import {EdwLoaderWithContainer} from '../common/edwLoaderWithContainer/EdwLoaderWithContainer'
import Tooltip from '../common/ToolTip/EdwTooltip'
import { AssessmentNoData } from "../common/noData/NoData";



export class GroupsByCourses extends Component {
    constructor(props) {
        super();
        this.state = {
            isDataLoaded: false,
            groupsData: []
        }
        this.iesToken = props.token ? props.token : '';
        this.activeAssessmentId = props.assessmentId;
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.groupId !== prevProps.groupId ||
            this.props.studentYear !== prevProps.studentYear
        ) {
            this.fetchData();
        }
    }



    fetchData = () => {
        let { schoolId } = this.props;

        asyncCallHandler(EDW_CONST.GROUP_END_POINT, `getGroupsDashboardListInfo?schoolId=${schoolId}&groupId=myGroup&subjectId=&courseId=`, this.iesToken).then(data => {
            this.setState({ isDataLoaded: true, groupsData: data.data});
        }).catch((error) => {
            this.setState({ groupsData: [], isDataLoaded: false });
        });
    }

    getGroupsList = () => {
       
        if (this.state.groupsData && this.state.groupsData.length > 0){
            let tpl = this.state.groupsData.map(data => {
                return <div className="group-by-course-card">
                    <div className="groups-by-course-title">Year {data.year} {data.courseName}</div>
                    {
                        data.groups.map(val => {

                            return <div className="col-md-12"><div className="row groups-by-item-block"><label className="edw-widget-title-link" onClick={() => this.props.clickHandler(val.groupId, data.courseId)}>{val.groupName}</label></div></div>
                        })
                    
                    }
                   </div>
                
            })
            return <div className="row no-gutters">
                <div className="col-md-12">
                    {tpl}
                </div>
                <div className="col-md-12 ">
                    <div><button onClick={() => this.props.history.push('/groups')} className="Button Button-BG IconRight">View groups</button></div>
                </div>
            </div> 
        }else{
            return <AssessmentNoData />
        }
        
    }

    render() {

        return (

            <div className="col">
                <div className="row">
                    <div className="col-md-12">
                        <span className="edw-widget-chart-title">Groups
                            
                        </span>
                    </div>
                </div>


                {this.state.isDataLoaded ? this.getGroupsList() : <div className="edw-full-width"><EdwLoaderWithContainer /></div>}

            </div>


        );
    }
}


